import type { MultiPolygon, Polygon } from 'geojson';

export const CITIES_ENDPOINT = '/api/boi/params/cities/';

export const CITIES_SYNC_ENDPOINT = `${CITIES_ENDPOINT}sync/`;

/**
 * Réponse de POST /api/boi/params/cities/sync/. L'appel est synchrone : au retour, le
 * job est terminé, et un échec de synchro arrive en 200 avec `status: 'FAILED'`.
 */
export type CitySyncResult = {
  status: 'IN_PROGRESS' | 'SUCCESS' | 'FAILED';
  job_id: number;
};

export const CITY_ORIGINS = ['DDP_CITY_REF', 'BDZ_PATRIMONY', 'CUSTOMER_PATRIMONY'] as const;

export type CityOrigin = (typeof CITY_ORIGINS)[number];

export type Country = {
  id: number;
  label: string;
};

export type City = {
  id: number;
  label: string;
  department_code: string | null;
  insee: string | null;
  zip_code: string | null;
  origin: CityOrigin;
  has_geom: boolean;
  timezone: string | null;
  country: number | null;
  country_data: Country | null;
  radio_mode: number | null;
  customers_count: number;
  contracts_count: number;
  created_at: number;
  updated_at: number;
};

export type CityContract = {
  id: number;
  oss_code: string;
  oss_label: string | null;
  sage_code: string | null;
  salesforce_code: string | null;
};

export type CityCustomer = {
  id: number;
  oss_code: string;
};

/** Réponse de GET /api/boi/params/cities/{id}/ : la ligne de liste, plus le contour et le détail. */
export type CityDetail = City & {
  geom: MultiPolygon | Polygon | null;
  contracts_data: CityContract[];
  customers_data: CityCustomer[];
};
